<template>
<div class='panel'>

  <h2>Microphone</h2>
  <div class='checkBoxes'>
    <div class='checkBox' v-for='index in 2' :key='index'>
      <label>{{microphones[index-1]}}</label>
      <input type='checkbox' :value='microphones[index-1]' v-model='checkedMics' @change='sendMicChecks'>
    </div>
  </div>
  <hr>

  <h2>Days</h2>
  <div class='checkBoxes'>
    <div class='checkBox' v-for='index in 7' :key='index'>
      <label>{{days[index-1]}}</label>
      <input type='checkbox' :value='days[index-1]' v-model='checkedDays' @change='sendChecks'>
    </div>
  </div>
  <hr>

  <h2>Date Range</h2>
  <div class='doubleSliderBox'>
    <double-slider v-on:handle-one="updateDateRangeMin" v-on:handle-two="updateDateRangeMax" />
  </div>
  <div class='dateRangeLabels'>
    <label class='date'>{{startDate}}</label>
    <label class='date'>{{endDate}}</label>
  </div>
  <hr>
  <h2>Time Range</h2>
  <div class='doubleSliderBox'>
    <double-slider v-on:handle-one="updateTimeMin" v-on:handle-two="updateTimeMax" />
  </div>
  <div class='dateRangeLabels'>
    <label class='date'>{{minsToTimeString(timeMin)}}</label>
    <label class='date'>{{minsToTimeString(timeMax)}}</label>
  </div>
  <hr>
  <div class='info' v-if='showInfo'>
    <h4>Catalog Number: {{catNum}}</h4>
    <h4>{{date}} &mdash; {{time}}</h4>
    <h4 v-html='weather'></h4>
    <h4 class='colloquialism'>{{colloquialism}}</h4>
  </div>


</div>
</template>

<script>
import DoubleSlider from './DoubleSlider';
import {
  EventBus
} from '@/eventBus.js'
const msPerDay = 1000 * 60 * 60 * 24;
const projectStartDate = new Date('April 7, 2019');
const currentDate = new Date();
const daysSinceStart = Math.ceil((currentDate - projectStartDate) / msPerDay);

const addDays = (date, days) => {
  const copy = new Date(Number(date));
  copy.setDate(date.getDate() + days)
  return copy
};


export default {
  name: "InfoPanel",
  data() {
    return {
      days: ['M', 'T', 'W', 'Th', 'F', 'Sa', 'Su'],
      microphones: ['H3-VR', 'NT-SF1'],
      checkedMics: ['H3-VR', 'NT-SF1'],
      checkedDays: ['M', 'T', 'W', 'Th', 'F', 'Sa', 'Su'],
      startDate: projectStartDate.toLocaleDateString(),
      endDate: currentDate.toLocaleDateString(),
      catNum: '',
      date: '',
      time: '',
      colloquialism: '',
      weather: '',
      showInfo: false,
      timeMin: 0,
      timeMax: 60 * 24,

    }
  },
  components: {
    DoubleSlider
  },

  mounted() {
    EventBus.$on('marker', this.handleMarker)
  },

  methods: {

    minsToTimeString(min) {
      let hours = (Math.floor(min / 60)).toString();
      let mins = (min % 60).toString();
      if (mins.length === 1) mins = '0' + mins;
      const meridiem = hours % 24 >= 12 ? 'PM' : 'AM';

      hours = hours % 12;
      if (hours === 0) hours = 12;
      return hours + ':' + mins + ' ' + meridiem;
    },

    sendChecks() {
      EventBus.$emit('days', this.checkedDays)
    },

    sendMicChecks() {
      EventBus.$emit('mics', this.checkedMics)
    },

    sendDateRange() {
      EventBus.$emit('dateRange', [this.startDate, this.endDate])
    },

    sendTimeRange() {
      EventBus.$emit('timeRange', [this.timeMin, this.timeMax])
    },

    handleMarker(m) {
      if (this.showInfo === false) this.showInfo = true;
      this.catNum = m.position.catNum;
      this.colloquialism = m.position.colloquialism;
      this.weather = m.position.temp.summary + ', ' + Math.round(m.position.temp.temperature) + `&deg;` +' F';

      const dateChunks = m.position.date.split('/');
      this.date = ([dateChunks[1], dateChunks[2], dateChunks[0]]).join('/');
      this.time = m.position.time;
    },

    updateDateRangeMin(e) {
      const dateOne = Math.round(e * daysSinceStart);
      this.startDate = addDays(projectStartDate, dateOne).toLocaleDateString();
      this.sendDateRange();

    },

    updateDateRangeMax(e) {
      const dateTwo = Math.round(e * daysSinceStart);
      this.endDate = addDays(projectStartDate, dateTwo).toLocaleDateString();
      this.sendDateRange();
    },

    updateTimeMin(e) {
      this.timeMin = Math.round(e * 60 * 24);
      this.sendTimeRange();
    },

    updateTimeMax(e) {
      this.timeMax = Math.round(e * 60 * 24);
      this.sendTimeRange();
    }
  }
}
</script>
<style scoped>
.panel {
  position: absolute;
  bottom: 41px;
  left: 0px;
  width: 300px;
  height: 800px;
  background-color: lightgrey;
  z-index: 1;
  border-top: 1px solid black;
  border-right: 1px solid black;
  display: flex;
  flex-direction: column;
  justify-content: top;
  align-items: center;
}

.checkBoxes {
  width: 85%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.checkBox {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
}

hr {
  width: 80%
}

.doubleSliderBox {
  width: 85%;
  height: 30px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  margin-bottom: 10px;
}

.dateRangeLabels {
  width: 100%;
  display: flex;
  justify-content: space-around;
}

.date {
  width: 80px;
  text-align: center;
}

h2 {
  margin: 10px;
}

h4 {
  text-align: center;
  margin-top: 10px;
  margin-bottom: 10px;
}

.colloquialism {
  width: 80%;
}

.info {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;

}
</style>
